import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NbDialogService } from '@nebular/theme';
import { CompanyService } from 'src/app/services/company.service';
import { DeleteExternComponent } from '../delete/delete.component';
import { EditExternComponent } from '../edit/edit.component';
import { Extern } from 'src/app/models/extern.model';
import { ExternService } from 'src/app/services/extern.service';
import { Company } from 'src/app/models/company.model';
import { SearchCompanyComponent } from '../search-company/search-company.component';
import { catchError, of, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ANIMAL_TYPES } from 'src/app/constants/animal-types.constants';

@Component({
    selector: 'app-show-extern',
    templateUrl: './show.component.html',
    styleUrls: ['./show.component.scss'],
    standalone: false
})
export class ShowExternComponent implements OnInit {

	public externId: number | null;
	public extern: Extern | null;
	public coopCompanies: Company[] | null = null;
	public uploadBaseUrl: string = environment.uploadBaseUrl;
	public animalTypes = ANIMAL_TYPES;

	constructor(
		protected route: ActivatedRoute,
		protected externService: ExternService,
		protected dialogService: NbDialogService,
		protected companyService: CompanyService,
		protected router: Router
	) {
		const externId = this.route.snapshot.paramMap.get('id');
		if (externId) {
			this.externId = parseInt(externId);
			this.reloadExtern();
		}
	}

	ngOnInit(): void {

	}

	private reloadExtern(): void {

		if (!this.externId) return;
		this.externService.getOne(this.externId).subscribe(
			extern => {
				this.extern = extern;
			}
		);
		this.companyService.getByCoopId(this.externId).subscribe(
			companies => {
				this.coopCompanies = companies;
			}
		);
	}

	public editAction(): void {

		this.dialogService.open(EditExternComponent, { context: { extern: this.extern } }).onClose.subscribe((externId: number | null) => {
			if (externId) {
				this.reloadExtern();
			}
		});
	}

	public reloadApiAction(): void {
		if (this.externId) {
			const confirmation = confirm('Êtes-vous sûr de vouloir renouveller la clé API ?');
			if (confirmation) {
				this.externService.reloadApi(this.externId).pipe(
					catchError((error, caught) => {
						return of(null);
					}),
					tap(extern => {
						this.reloadExtern();

					}),
				).subscribe();
			}
		}
	}

	public deleteAction(): void {
		this.dialogService.open(DeleteExternComponent, { context: { extern: this.extern } }).onClose.subscribe((response) => {
			if (response.deleted) {
				this.router.navigateByUrl('/externs');
			}
		});
	}

	public addAction(): void {

		const companiesToFilter = this.extern?.companies?.map(company => company.id);
		this.dialogService.open(SearchCompanyComponent, { context: { companiesToFilter } }).onClose.subscribe((response) => {
			if (response && response.id && this.externId) {
				this.externService.linkCompany(this.externId, response.id).pipe(
					catchError((error, caught) => {
						return of(null);
					}),
					tap(extern => {
						this.reloadExtern();

					}),
				).subscribe();
			}
		});
	}
	public deleteCompanyAction(company: Company): void {
		if (!this.externId) return;
		this.externService.unlinkCompany(this.externId, company.id).pipe(
			catchError((error, caught) => {
				return of(null);
			}),
			tap(extern => {
				this.reloadExtern();

			}),
		).subscribe();
	}

	public isAnimalTypeSelected(typeId: number): boolean {
		return this.extern?.animalTypeIds?.includes(typeId) ?? false;
	}
}
